<template>
  <main class="page news-page" v-if="$store.state.document">
    <div class="news-page__container">
      <ul class="breadcrumbs">
        <li class="breadcrumbs__item">
          <router-link :to="{ name: 'home'}">Главная</router-link>
        </li>
        <li class="breadcrumbs__item">
          <router-link :to="{ name: 'documents'}">Документы</router-link>
        </li>
        <li class="breadcrumbs__item">
          <router-link :to="{ name: 'documentsOpen', params: { id: $route.params.cat_id }}">{{ title }}</router-link>
        </li>
        <li class="breadcrumbs__item">
          <span>{{ $store.state.document.title }}</span>
        </li>
      </ul>
      <div class="news-page__article news-page__article--wide">
        <h1 class="news-page__title">{{ $store.state.document.title }}</h1>
        <div class="news-page__content" v-html="$store.state.document.description"></div>
        <a :href="$store.state.document.url" download class="button">Скачать документ</a>
        <time class="news-page__time" :datetime="$store.state.document.date_publication | robotDate">Опубликовано {{ $store.state.document.date_publication | humanDate}}</time>
      </div>
      <div class="news-page__share news-page__share--wide">
        <span class="news-page__share__title">Поделиться</span>
        <div class="news-page__share__buttons">
          <ShareNetwork :url="$store.state.path" description="Описание" media="/public/img/main.png" network="vk" title="Заголовок">
            <ShareVK/>
          </ShareNetwork>
          <ShareNetwork :url="$store.state.path" network="odnoklassniki" title="Заголовок">
            <ShareOK/>
          </ShareNetwork>
          <ShareNetwork :url="$store.state.path" network="twitter" title="Заголовок">
            <ShareTW/>
          </ShareNetwork>
          <ShareNetwork :url="$store.state.path" description="Описание" network="whatsapp" title="Заголовок">
            <ShareWH/>
          </ShareNetwork>
          <ShareNetwork :url="$store.state.path" description="Описание" network="telegram" title="Заголовок">
            <ShareTM/>
          </ShareNetwork>
        </div>
      </div>
    </div>
  </main>
</template>

<script>

import ShareFB from 'components/svg/ShareFB.vue'
import ShareVK from 'components/svg/ShareVK.vue'
import ShareOK from 'components/svg/ShareOK.vue'
import ShareWH from 'components/svg/ShareWH.vue'
import ShareTM from 'components/svg/ShareTM.vue'
import ShareTW from 'components/svg/ShareTW.vue'

export default {
  components: {
    ShareTW,
    ShareTM,
    ShareWH,
    ShareOK,
    ShareVK,
    ShareFB
  },
  async asyncData ({ store, host, route }) {
    store.state.path = `https://${host}${route.path}`
    await store.dispatch('DOCUMENTS_SHOW_PAGE', {
      catId: route.params.cat_id,
      id: route.params.id
    })
  },
  name: 'DocumentsShowPage',
  computed: {
    title () {
      const categories = this.$store.state.categories.filter(item => item.id === parseInt(this.$route.params.cat_id))
      return categories[0] ? categories[0].title : ''
    }
  },
  metaInfo () {
    return this.$store.state.document ? this.$seo(
      'common',
      this.$store.state.document.title,
      'управление образования, образование, администрация',
      this.title,
      this.$store.state.document.title,
      '',
      this.title
    ) : this.$seo('common', '', '', '', '', '', '')
  }
}
</script>
